"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handlePhoneNigeriaNumberInput = exports.handleDate = exports.isValidNigerianPhoneNumber = void 0;
exports.formatNigeriaNumber = formatNigeriaNumber;
const date_fns_1 = require("date-fns");
const isValidNigerianPhoneNumber = (input) => {
    const localPhoneRegex = /^0[7-9][0-1][0-9]{8}$/;
    return localPhoneRegex.test(input.trim());
};
exports.isValidNigerianPhoneNumber = isValidNigerianPhoneNumber;
function formatNigeriaNumber(num, minDecimal = 2, maxDecimal = 2) {
    if (num === null || num === undefined) {
        return "";
    }
    const formatter = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: minDecimal,
        maximumFractionDigits: maxDecimal,
    });
    return formatter.format(num);
}
const handleDate = (date) => {
    if (date === null || date === undefined) {
        return "";
    }
    return (0, date_fns_1.format)(new Date(date), "dd/MM/yyyy");
    // return new Date(date).toLocaleDateString();
};
exports.handleDate = handleDate;
const handlePhoneNigeriaNumberInput = (input) => {
    const phoneRegex = /^(0\d{10}|234\d{10})$/;
    let phone = "";
    let phone234 = "";
    let passCheck = false;
    if (phoneRegex.test(input)) {
        passCheck = true;
        if (input.startsWith("0")) {
            phone = input;
            phone234 = "234" + input.slice(1);
        }
        else if (input.startsWith("234")) {
            phone234 = input;
            phone = "0" + input.slice(3);
        }
    }
    return {
        phone234,
        phone,
        passCheck,
    };
};
exports.handlePhoneNigeriaNumberInput = handlePhoneNigeriaNumberInput;
//# sourceMappingURL=phoneNumber.js.map